import '@nodeModules/slick-carousel-latest/slick/slick.scss';
import '@nodeModules/flatpickr/dist/flatpickr.min.css';
import '@nodeModules/flatpickr/dist/themes/airbnb.css';
import '@/style/app.scss';
import '@/style/pages/search/search.scss';
import { initSentry } from '@/js/services/sentry.js';
import { initGDPRConsent } from '@/js/partials/gdpr-consent.js';
import { initHeader } from '@/js/partials/header.js';
import { initNewsletterForms } from '@/js/partials/newsletter.js';
import { initTracking } from '@/js/services/tracking.js';
import { initModals } from '@/js/partials/modals.js';
import { initSearchAutocomplete } from '@/js/partials/search-autocomplete.js';
import { initFeaturedLocations } from '@/js/partials/featured-locations.js';
import { initFeaturedBrands } from '@/js/partials/featured-brands.js';
import { initPageJs } from '@/js/pages/search.js';

window.addEventListener('DOMContentLoaded', () => {
	initSentry();
	initGDPRConsent();
	initHeader();
	initNewsletterForms();
	initTracking();
	initModals();

	const $form = document.querySelector('.search__form');
	initSearchAutocomplete($form);

	initFeaturedLocations();
	initFeaturedBrands();
	initPageJs();
});
